import { Component, DestroyRef, effect, EffectRef, ElementRef, inject, signal, Signal, ViewChild, WritableSignal } from '@angular/core';
import { ButtonComponent } from '@components/shared/button/button.component';
import { ButtonType } from '@models/enums/components/Button/ButtonType.enum';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { MobileButtonService } from '@services/components/mobile-button.service';
import { DvmService } from '@services/dvm.service';
import anime from 'animejs';

@Component({
    selector: 'app-mobile-button',
    imports: [
        ButtonComponent
    ],
    templateUrl: './mobile-button.component.html',
    styleUrl: './mobile-button.component.css'
})
export class MobileButtonComponent {

  // VIEW CHILDREN
  @ViewChild('mobileBtn', { read: ElementRef })
  private readonly mobileBtn!:  ElementRef<ButtonComponent>;

  // SERVICES
  private readonly view:        Signal<AppViews| null> = inject(DvmService).view;
  private readonly destroyRef:  DestroyRef             = inject(DestroyRef);
  public  readonly service:     MobileButtonService    = inject(MobileButtonService);

  // STATE
  public readonly showElement:  WritableSignal<boolean> = signal(this.view() === AppViews.Topview || this.view() === AppViews.Main);
  public          isActive:     boolean     = false;
  public readonly buttonType:   ButtonType  = ButtonType.Pill;
  private animationTimer:       ReturnType<typeof setTimeout> | null = null;

  // EFFECT
  public readonly toggleVisibility: EffectRef = effect((): void=> {

    const view: AppViews | null = this.view(),
          show: boolean = view === AppViews.Topview || view === AppViews.Main;

    if(view === null) return;

    if(this.showElement()) this.animateButton(show);    
    else {
      this.clearAnimationTimer();
      this.animationTimer = window.setTimeout((): void => {
        this.animateButton(show);
        this.animationTimer = null;
      }, 300);
    }
  
  })

  constructor() {
    this.destroyRef.onDestroy((): void => this.clearAnimationTimer());
  }

  private animateButton(show: boolean): void {
    
    anime({
      begin:    (): void => { if(show && !this.showElement()) this.showElement.set(true); },
      complete: (): void => { 
        if(!show && this.showElement()) this.showElement.set(false);
        if(!this.showElement() && this.service.active()) this.service.toggleButton();
      },
      targets:  this.mobileBtn.nativeElement,
      opacity:  show ? 1 : 0,
      duration: 300,
      easing:   'easeInOutQuad',
    })

  }

  private clearAnimationTimer(): void {
    if(!this.animationTimer) return;
    clearTimeout(this.animationTimer);
    this.animationTimer = null;
  }

}
